var m = require('mithril');
var dragscroll = require('../../libs/dragscroll');
var Draggable = require('../../libs/draggable');
var loaders = require('../../layout/components/loaders');
var edit = require('../../layout/components/edit');
var modalForm = require('../../layout/components/modalForm');
var pointTd = require('../../data/components/pointTd');
var tableHeader = require('./tableHeader');
var columnForm = require('../../data/components/columnModal');
var datasetForm = modalForm(require('../../data/models/dataset'));
var extendedPropsNumberForm = modalForm(require('../models/extendedPropsNumber'));
var extendedPropsStringForm = modalForm(require('../models/extendedPropsString'));
var session = require('../../auth/models/session');
var d3 = require('d3');
var Point = require('../../data/models/point');
var pointTrendModal = require('../../data/components/pointTrendModal');

var table = {};
var unnamedRowLabel = 'Unnamed row';
var defaultPreferredTableViewSpan = '30d';

function getElementRecord (element) {
  return typeof element === 'function' ? element() : element;
}

function ridToId (rid) {
  return String(rid || '').replace(/^#/, '');
}

function getContainsEdges (elementRecord) {
  return Array.isArray(elementRecord && elementRecord.out_Contains) ? elementRecord.out_Contains : [];
}

function getPointWriteParentRid (elementRecord) {
  var locationRecord = elementRecord && elementRecord.location && elementRecord.location();
  return locationRecord && locationRecord['@class'] === 'Dashboard'
    ? elementRecord.parentRid
    : elementRecord && elementRecord['@rid'];
}

function normalizeColumns (elementRecord) {
  if (!elementRecord) {
    return [];
  }
  if (!Array.isArray(elementRecord.columns)) {
    elementRecord.columns = getColumns(elementRecord);
  }
  return elementRecord.columns;
}

function columnId (col, idx) {
  if (typeof col === 'string') {
    return col;
  }
  return typeof col.id === 'undefined' ? idx : col.id;
}

function columnName (col) {
  return typeof col === 'string' ? col : (col.name || '');
}

function columnType (col) {
  return typeof col === 'string' ? 'point' : (col.type || 'point');
}

function columnTextAlign (col) {
  return typeof col === 'string' ? 'left' : (col.textAlign || 'left');
}

function datasetName (dataset) {
  return String(dataset && dataset.name || '').trim();
}

function editDatasetHandle (dataset) {
  var name = datasetName(dataset);
  return name || m('i.ion-arrow-move', {'aria-hidden': 'true'});
}

function editDatasetAttrs (dataset, ctrl) {
  var label = datasetName(dataset) || unnamedRowLabel;
  return {
    onclick: datasetForm.editDialogue.bind(datasetForm, dataset, {delete: true, submitCallback: ctrl.parentReinitialize, dashboardCallback: ctrl.parentReinitialize}),
    title: label,
    'aria-label': label
  };
}

function trendLink(columnRecord, children) {
  return m('a.ph1.f4.pointer.tl.flex.justify', {
    href: '#',
    onclick: function (event) {
      event.preventDefault();
      pointTrendModal.open(columnRecord);
    },
    'aria-haspopup': 'dialog',
    title: 'View trend chart',
    'data-point-rid': columnRecord && columnRecord.in && columnRecord.in['@rid']
  }, children);
}

function findColumnRecord (dataset, col, idx) {
  if (!Array.isArray(dataset.out_Column)) {
    return undefined;
  }

  var id = columnId(col, idx);
  var name = columnName(col);
  return dataset.out_Column.find(function (e) {
    return e.index === id || (name && e.name === name);
  });
}

function normalizePreferredTableViewRecord (record, elementRecord) {
  var elementRid = ridToId(elementRecord && elementRecord['@rid']);
  if (!record || !elementRid || !Object.prototype.hasOwnProperty.call(record, elementRid)) {
    return undefined;
  }

  var value = record[elementRid];
  var aggregate;
  var span;

  if (typeof value === 'string') {
    aggregate = value;
    span = defaultPreferredTableViewSpan;
  } else if (value && typeof value === 'object') {
    aggregate = value.aggregate;
    span = value.span || defaultPreferredTableViewSpan;
  }

  if (!aggregate || aggregate === 'default') {
    return undefined;
  }

  var normalized = {};
  normalized[elementRid] = Object.assign({}, value && typeof value === 'object' ? value : {}, {
    aggregate: aggregate,
    span: String(span || defaultPreferredTableViewSpan)
  });
  return normalized;
}

function getPreferredTableViewRecord (elementRecord) {
  var user = session.user && session.user();
  var preferredTableView = user && user.preferredTableView;
  var elementRid = ridToId(elementRecord && elementRecord['@rid']);
  if (!Array.isArray(preferredTableView) || !elementRid) {
    return undefined;
  }

  var record = preferredTableView.find(function (element) {
    return element && Object.prototype.hasOwnProperty.call(element, elementRid);
  });
  return normalizePreferredTableViewRecord(record, elementRecord);
}

function getPreferredTableViewConfig (ctrl) {
  var elementRecord = getElementRecord(ctrl.element);
  var elementRid = ridToId(elementRecord && elementRecord['@rid']);
  return ctrl.preferredTableView && elementRid ? ctrl.preferredTableView[elementRid] : undefined;
}

table.oninit = function (vnode) {
  var ctrl = this;
  ctrl.element = vnode.attrs.element;
  ctrl.OrMenuOptions = vnode.attrs.OrMenuOptions
  ctrl.hidePreferredViewMenu = vnode.attrs.hidePreferredViewMenu
  ctrl.parentReinitialize = vnode.attrs.parentReinitialize;
  ctrl.dashboardCallback = vnode.attrs.dashboardCallback;
  ctrl.summaryError = null;
  ctrl.summaryLoading = false;
  ctrl.summaryRequestId = 0;
  ctrl.orderError = null;

  if (!ctrl.element || !ctrl.element()) {
    return;
  }

  ctrl.preferredTableView = getPreferredTableViewRecord(getElementRecord(ctrl.element));

  ctrl.loadSummary = function () {
    if (ctrl.hidePreferredViewMenu && ctrl.OrMenuOptions.ORViewMode != 'live') {
      return getOrSummary(ctrl);
    }

    var preferredTableViewConfig = getPreferredTableViewConfig(ctrl);
    if (preferredTableViewConfig && preferredTableViewConfig.aggregate !== 'live') {
      return getPoints(ctrl);
    }
    if (ctrl.element().preferredTableView !== 'live' && ctrl.element().preferredTableView !== '' && ctrl.element().preferredTableView) {
      return getPoints(ctrl);
    }
    return Promise.resolve(null);
  };
  ctrl.loadSummary();
    
  normalizeColumns(getElementRecord(ctrl.element));
  
  ctrl.sortChildren = (datasets) => {
    var elementRecord = getElementRecord(ctrl.element);
    if (!elementRecord || !elementRecord['@rid']) {
      return Promise.resolve();
    }
    var rids = (datasets || []).map(n => n.attributes.rid.value);
    return loaders.requestWithLoader({
      loader: 'background',
      method: 'PUT',
      url: '/api/v1/element/' + elementRecord['@rid'].slice(1) + '/childorder',
      body: {rids: rids}
    })
    .then(function (result) {
      ctrl.orderError = null;
      return ctrl.parentReinitialize ? ctrl.parentReinitialize() : result;
    })
    .catch(function (error) {
      console.error('Unable to save table order:', error);
      ctrl.orderError = 'Unable to save the new order. The latest saved order was reloaded.';
      m.redraw();
      return Promise.resolve(ctrl.parentReinitialize ? ctrl.parentReinitialize() : null)
        .catch(function (reloadError) {
          console.error('Unable to reload table after an order failure:', reloadError);
          return null;
        })
        .then(function () {
          return null;
        });
    });
  };
  
  ctrl.sortOnIndex = (a,b) => {
    return (a.index || 0) - (b.index || 0);
  }
}

table.onupdate = function (vnode) {
  var ctrl = this;
  ctrl.element = vnode.attrs.element;

  if (!ctrl.element || !ctrl.element()) {
    return;
  }

  ctrl.preferredTableView = getPreferredTableViewRecord(getElementRecord(ctrl.element));
  
  normalizeColumns(getElementRecord(ctrl.element));
  //return element;
}

table.oncreate = () => {
  dragscroll()
}

table.view = function (vnode) {
  var ctrl = this
  ctrl.element = vnode.attrs.element || ctrl.element;
  if (!ctrl.element || !ctrl.element()) {
    return null;
  }
  return m('div', [
    tableErrorView(ctrl),
    edit.vm.editing() ? buildView(ctrl.element, ctrl) : browseView(ctrl.element, ctrl)
  ]);
}

function tableErrorView (ctrl) {
  var message = ctrl.summaryError || ctrl.orderError;
  if (!message) return null;

  return m('div.mt2.mb2.dark-red', [
    m('span', message + ' '),
    ctrl.summaryError && ctrl.loadSummary
      ? m('button', { type: 'button', onclick: ctrl.loadSummary }, 'Retry')
      : null
  ]);
}

function buildView (element, ctrl) {
  var elementRecord = getElementRecord(element);
  if (!elementRecord) {
    return null;
  }

  var containsEdges = getContainsEdges(elementRecord);
  var columns = normalizeColumns(elementRecord);

  containsEdges.sort(ctrl.sortOnIndex);
  return m('div.dragscroll-container', [
    m('div.dragscroll', [
      m('table.fw2.f3.pr4.pb3.narrow', {style: {tableLayout: 'fixed'}}, [
        m(tableHeader, {elementRecord:element, parentReinitialize: ctrl.parentReinitialize, dashboardCallback: ctrl.dashboardCallback}),
        m(Draggable, {onsort: ctrl.sortChildren, draggable: '.grid-table', handleClass:'.grid-table-drag-handle', htmlElement: 'tbody', submitCallback: ctrl.parentReinitialize},
          containsEdges.map(function (containsEdge) {
            var dataset = containsEdge.in;
            if (elementRecord.path) {
              dataset.path = [
                ...elementRecord.path, 
                {
                  name: dataset.name || dataset['@class'],
                  '@rid': dataset['@rid']
                }
              ];
            } else {
              dataset.path = [];
            } 
            return m('tr.grid-table', {rid: containsEdge['@rid'], key: dataset['@rid']}, [
              (function () {
                if (dataset.url) {
                  return m('td.bb.moon-gray.nowrap.pr3.overflow-hidden.grid-table-drag-handle',  [
                    m('a.blue', editDatasetAttrs(dataset, ctrl), editDatasetHandle(dataset))
                  ]);
                } else {
                  return m('td.bb.moon-gray.nowrap.pr3.overflow-hidden.grid-table-drag-handle', [
                    m('a.blue', editDatasetAttrs(dataset, ctrl), editDatasetHandle(dataset))
                  ]);
                }
              })(),
              columns.map(function (col, idx) {
                var columnRecord;
                var tdForm;
                if (columnType(col) !== 'point') {
                  if (columnType(col) === 'number') {
                    tdForm = extendedPropsNumberForm;
                  } else if (columnType(col) === 'string') {
                    tdForm = extendedPropsStringForm;
                  }
                  return m('td.bb.bl-0', {key: columnId(col, idx)}, [
                    m('div.tc', 
                      {
                        onclick: tdForm.editDialogue.bind(tdForm, dataset, {property: columnId(col, idx), submitCallback: ctrl.parentReinitialize})
                      }, 
                      [
                        m('span.blue', dataset.extendedProps && dataset.extendedProps[columnId(col, idx)] ? dataset.extendedProps[columnId(col, idx)] : m('i.ion-plus.blue'))
                      ]
                    )  //a
                  ]); // td
                
                } else {
                  columnRecord = findColumnRecord(dataset, col, idx);

                  if (typeof columnRecord === 'undefined') {
                    return m('td.bb.bl-0', {key: columnId(col, idx)},[
                      m('div.tc', 
                        {
                          onclick: columnForm.editDialogue.bind(columnForm, {out: dataset['@rid'], index: columnId(col, idx), path: dataset.path}, {columnName: columnName(col), delete: true, submitCallback: ctrl.parentReinitialize, dashboardCallback: ctrl.parentReinitialize})
                        }, 
                        [
                          m('i.ion-plus.blue')
                        ]
                      )  //a
                    ]) // td
                  } else {
                    columnRecord.key = columnRecord['@rid'];
                    columnRecord.path = dataset.path;
                    return m(pointTd, {key: columnId(col, idx), columnRecord:columnRecord, parentReinitialize: ctrl.parentReinitialize, textAlign: columnTextAlign(col), parentRid: getPointWriteParentRid(elementRecord)})
                  }
                }
              }),
              m('td.tc.v-btm.bb.pv1', { style: { width: '99%'}})
            ])
          }),
          m('tr', [
            m('td.bb.bl-0.tc', [
              m('i.icon.ion-plus.blue', {onclick: datasetForm.editDialogue.bind(datasetForm, {parent: elementRecord['@rid']}, {submitCallback: ctrl.parentReinitialize})})
            ])
          ])  
        )
      ])
    ])
  ]);
};

function browseView (element, ctrl) {
  var elementRecord = getElementRecord(element);
  if (!elementRecord) {
    return null;
  }

  var containsEdges = getContainsEdges(elementRecord);
  var columns = normalizeColumns(elementRecord);

  containsEdges.sort(ctrl.sortOnIndex);
  return m('div.dragscroll-container', [
    m('div.dragscroll', [
      m('table.f3.pr4.pb3.narrow', {style: {tableLayout: 'fixed'}}, [
        m(tableHeader, {elementRecord:element, parentReinitialize: ctrl.parentReinitialize, hidePreferredViewMenu: ctrl.hidePreferredViewMenu}),
        m('tbody', [
          containsEdges.map(function (containsEdge) {
            var dataset = containsEdge.in;
            return m('tr', [
              (function () {
                if (dataset.url) {
                  return m('td.bb.moon-gray.tl.nowrap.pr3.overflow-hidden', [
                    m('a', {href: dataset.url}, dataset.name)
                  ]);
                } else {
                  return m('td.bb.moon-gray.tl.nowrap.pr3.overflow-hidden', dataset.name);
                }
              })(),
              columns.map(function (col, idx) {
                var id = columnId(col, idx);
                var propResult = dataset.extendedProps && dataset.extendedProps[id];
                var color = d3.scale.linear().domain([50, 85, 100]).range(["red", "rgba(68, 68, 68, 1)", "green"]);
                var columnRecord = findColumnRecord(dataset, col, idx);
                if (ctrl.timeseriesReduce) {
                  let timeseriesReduce = ctrl.timeseriesReduce.find( aggregateValue =>{ 
                    if (columnRecord && aggregateValue.id == columnRecord.in['@rid']) {
                      return timeseriesReduce
                    } 
                  })
                  var preferredTableViewConfig = getPreferredTableViewConfig(ctrl);
                  if (timeseriesReduce && (preferredTableViewConfig && preferredTableViewConfig.aggregate == 'mean' || ctrl.element().preferredTableView == 'mean')) {
                    return m('td.bb.narrow.nowrap', {style: {"text-align":"center"}}, [
                      trendLink(columnRecord, [
                        m('span.ma0', Point.readValue(Object.assign(columnRecord.in, {value: timeseriesReduce._value}))),
                      ]),
                      m('span.v-top.dib.moon-gray', {style: {fontSize: '10px'}}, '  ' + Point.formatUnit(columnRecord.in))
                    ]);
                  }
                  if (timeseriesReduce && (preferredTableViewConfig && preferredTableViewConfig.aggregate == 'max' || ctrl.element().preferredTableView == 'max')) {
                    return m('td.bb.narrow.nowrap', {style: {"text-align":"center"}}, [
                      trendLink(columnRecord, [
                        m('span.ma0', Point.readValue(Object.assign(columnRecord.in, {value: timeseriesReduce._value}))),
                        m('span.v-top.dib.moon-gray', {style: {fontSize: '10px'}}, '  ' + Point.formatUnit(columnRecord.in))
                      ])
                    ]);
                  }
                  if (timeseriesReduce && (preferredTableViewConfig && preferredTableViewConfig.aggregate == 'min' || ctrl.element().preferredTableView == 'min')) {
                    return m('td.bb.narrow.nowrap', {style: {"text-align":"center"}}, [
                      trendLink(columnRecord, [
                        m('span.ma0', Point.readValue(Object.assign(columnRecord.in, {value: timeseriesReduce._value}))),
                        m('span.v-top.dib.moon-gray', {style: {fontSize: '10px'}}, '  ' + Point.formatUnit(columnRecord.in))
                      ])
                    ]);
                  }
                  if (timeseriesReduce && (preferredTableViewConfig && preferredTableViewConfig.aggregate == 'nominal_percent' || ctrl.element().preferredTableView == 'nominal_percent')) {
                    return m('td.bb.narrow.nowrap', {style: {"text-align":"center", "background-color": color(timeseriesReduce._value)}}, [
                      trendLink(columnRecord, [
                        m('span.ma0.white', d3.format(',.2f')(timeseriesReduce._value)),
                        m('span.v-top.dib.moon-gray', {style: {fontSize: '10px'}}, '  ' + '%')
                      ])
                    ]);
                  }
                
                }
                if (ctrl.ORtimeseriesReduce) {
                  let ORtimeseriesReduce = ctrl.ORtimeseriesReduce.find( timeseriesReduce =>{ 
                    if (columnRecord && timeseriesReduce.id == columnRecord.in['@rid']) { 
                      return timeseriesReduce
                    } 
                  })
                  if (ORtimeseriesReduce && ctrl.OrMenuOptions.ORViewMode == "compliance") {
                    return m('td.bb.narrow.nowrap', {style: {"text-align":"center", "background-color": color(ORtimeseriesReduce._value)}}, [
                      trendLink(columnRecord, [
                        m('span.ma0.white', d3.format(',.2f')(ORtimeseriesReduce._value)),
                        m('span.v-top.dib.moon-gray', {style: {fontSize: '10px'}}, '  ' + '%')
                      ])
                    ]);
                  }
                  if (ORtimeseriesReduce && ctrl.OrMenuOptions.ORViewMode == "max") {
                    return m('td.bb.narrow.nowrap', {style: {"text-align":"center"}}, [
                      trendLink(columnRecord, [
                        m('span.ma0.white', Point.readValue(Object.assign(columnRecord.in, {value: ORtimeseriesReduce._value}))),
                        m('span.v-top.dib.moon-gray', {style: {fontSize: '10px'}}, '  ' + Point.formatUnit(columnRecord.in))
                      ])
                    ]);
                  }
                  if (ORtimeseriesReduce && ctrl.OrMenuOptions.ORViewMode == "min") {
                    return m('td.bb.narrow.nowrap', {style: {"text-align":"center"}}, [
                      trendLink(columnRecord, [
                        m('span.ma0.white', Point.readValue(Object.assign(columnRecord.in, {value: ORtimeseriesReduce._value}))),
                        m('span.v-top.dib.moon-gray', {style: {fontSize: '10px'}}, '  ' + Point.formatUnit(columnRecord.in))
                      ])
                    ]);
                  }
                }               
                if (propResult) {
                  return m('td.bb.narrow.nowrap', {style:{"text-align": columnTextAlign(col)}} , propResult); ;
                }
                
                if (!Array.isArray(dataset.out_Column)) {
                  return m('td.tc.bb.moon-gray', {style:{"text-align": columnTextAlign(col)}}, m('span', ' '));
                }

                if (typeof columnRecord === 'undefined') {
                  return m('td.tc.bb.moon-gray', {style:{"text-align": columnTextAlign(col)}}, m('span', ' '));
                }

                columnRecord.permission = elementRecord.permission;
                return m(pointTd, {columnRecord:columnRecord, textAlign: columnTextAlign(col), parentRid: getPointWriteParentRid(elementRecord)});
              }),
              m('td.tc.v-btm.bb.pv1', {style: { width: '99%'}})
            ])
          })
        ])
      ])
    ])
  ]);
}

function requestSummary (ctrl, request, assignResult) {
  var requestId = (ctrl.summaryRequestId || 0) + 1;
  ctrl.summaryRequestId = requestId;
  ctrl.summaryError = null;
  ctrl.summaryLoading = true;

  return request
    .then(function (response) {
      if (requestId === ctrl.summaryRequestId) {
        assignResult(response);
      }
      return response;
    })
    .catch(function (error) {
      if (requestId === ctrl.summaryRequestId) {
        console.error('Unable to load table summary:', error);
        ctrl.summaryError = 'Unable to load summarized values.';
      }
      return null;
    })
    .then(function (result) {
      if (requestId === ctrl.summaryRequestId) {
        ctrl.summaryLoading = false;
        m.redraw();
      }
      return result;
    });
}

var getPoints = (ctrl) => {
  var pointsRids = [];
  getContainsEdges(ctrl.element()).forEach(function (containsEdge) {
    var dataset = containsEdge.in;
      dataset && dataset.out_Column ? dataset.out_Column.forEach(function (column) {
        if (typeof column.in === 'object') pointsRids.push(column.in['@rid']);
        if (typeof column.in === 'string') pointsRids.push(column.in);        
      }) : null;
  });
  
  if (pointsRids.length >0) {
    var preferredTableViewConfig = getPreferredTableViewConfig(ctrl);
    let bucket = "default"
    let sampling =  preferredTableViewConfig ? preferredTableViewConfig.span[preferredTableViewConfig.span.length - 1] : 'd';
    sampling == 'h' ? bucket = '3_years' : ''
    sampling == 'd' ? bucket = '10_years' : ''
    var options = {
      start: "-" + (preferredTableViewConfig ? preferredTableViewConfig.span : ctrl.element().timeseriesSpan + ctrl.element().timeseriesSampling),
      stop: "now()",
      aggregate: (preferredTableViewConfig ? preferredTableViewConfig.aggregate : ctrl.element().preferredTableView),
      field: preferredTableViewConfig && preferredTableViewConfig.aggregate == "nominal_percent" ? "nominal_percent" : "value",
      bucket:  bucket
    }
    if (typeof preferredTableViewConfig != "undefined") {
      if (preferredTableViewConfig.aggregate =='nominal_percent') {
        options.field = 'nominal_percent'
        options.aggregate = 'mean'
      } else {
        options.field = preferredTableViewConfig.aggregate;
        options.aggregate = preferredTableViewConfig.aggregate;
      }
    } else if (ctrl.element().preferredTableView =='nominal_percent') {
      options.field = 'nominal_percent'
      options.aggregate = 'mean'
    } else if (ctrl.element().preferredTableView) {
      options.field = 'value'
      options.aggregate = ctrl.element().preferredTableView
    }
  
    return requestSummary(ctrl, loaders.requestWithLoader({
      method: 'GET',
      url: '/api/v1/data/timeseries/reduce/',
      params: {
        rids: pointsRids,
        options: options
      }
    }), function (response) {
      ctrl.timeseriesReduce = response;
    });
  }
  ctrl.summaryError = null;
  ctrl.summaryLoading = false;
  return Promise.resolve(null);
};

var getOrSummary = (ctrl) => {
  var pointsRids = [];
  getContainsEdges(ctrl.element()).forEach(function (containsEdge) {
    var dataset = containsEdge.in;
      dataset && dataset.out_Column ? dataset.out_Column.forEach(function (column) {
        if (typeof column.in === 'object') pointsRids.push(column.in['@rid']);
        if (typeof column.in === 'string') pointsRids.push(column.in);        
      }) : null;
  });
  
  if (pointsRids.length >0) {
    let bucket = "3_years";
    let start = new Date(ctrl.OrMenuOptions.ORStartDateTableView());
    start.setDate(start.getDate() - ctrl.OrMenuOptions.ORSpan());
    start = start.toISOString();

    var options = {
      start: start,
      stop: new Date(ctrl.OrMenuOptions.ORStartDateTableView()).toISOString(),
      aggregate: ctrl.OrMenuOptions.ORViewMode == "compliance" ? "mean" : ctrl.OrMenuOptions.ORViewMode,
      field: ctrl.OrMenuOptions.ORViewMode == "compliance" ? "nominal_percent" : ctrl.OrMenuOptions.ORViewMode,
      bucket:  bucket
    }

    return requestSummary(ctrl, loaders.requestWithLoader({
      method: 'GET',
      url: '/api/v1/data/timeseries/reduce/',
      params: {
        rids: pointsRids,
        options: options
      }
    }), function (response) {
      ctrl.ORtimeseriesReduce = response;
    });
  }
  ctrl.summaryError = null;
  ctrl.summaryLoading = false;
  return Promise.resolve(null);
};


function getColumns (element) {
  var labels = {}; // Using this like a Set
  var columns = [];

  getContainsEdges(element).forEach(function (containsEdge) {
    if (!containsEdge.in || !Array.isArray(containsEdge.in.out_Column)) {
      return
    }
    containsEdge.in.out_Column.forEach(function (pd) {
      if (!labels[pd.name]) {
        labels[pd.name] = {
          name: pd.name,
          id: typeof pd.index === 'undefined' ? columns.length : pd.index,
          type: 'point',
          index: typeof pd.index === 'undefined' ? columns.length : pd.index
        };
      }
    })
  })

  for (var property in labels) {
    columns.push(labels[property])
  }

  return columns
}

function addDays(date, days) {
  var result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

table._test = {
  trendLink: trendLink,
  getPoints: getPoints,
  getOrSummary: getOrSummary,
  tableErrorView: tableErrorView
};

module.exports = table;
